import {useApp} from '../app';

/**
 * Name 图片自适应居中显示实现方案
 * @param {*} img
 */
function getNaturalSize(img) {
    var naturalSize = {}
    if (img.naturalWidth && img.naturalHeight) {
        naturalSize.width = img.naturalWidth
        naturalSize.height = img.naturalHeight
    } else {
        var image = new Image()
        image.src = img.src
        image.onload = () => {
            naturalSize.width = image.width
            naturalSize.height = image.height
        }
    }
    return naturalSize
}
let autoimg = {
    updated(el) {
        const parentW = el.parentNode.clientWidth
        const parentH = el.parentNode.clientHeight
        const ratio = parentW / parentH
        el.style.display = 'none'
        el.onload = () => {
            setStyle()
        }
        if (el.complete) {
            setStyle()
        }
        function setStyle() {
            const actualObj = getNaturalSize(el)
            const imgRatio = actualObj.width / actualObj.height
            el.style.display = 'inline-block'
            el.style.width = '100%'
            el.style.height = '100%'
            el.style.maxWidth = 'none'
            if (ratio < imgRatio) {
                el.style.width = 'auto'
                el.style.height = '100%'
            } else if (ratio > imgRatio) {
                el.style.width = '100%'
                el.style.height = 'auto'
            }
            el.style.position = 'relative'
            el.style.top = '50%'
            el.style.left = '50%'
            el.style.transform = 'translate(-50%, -50%)'
        }
    }
}
// 图片自适应居中end

// 只允许输入数字的指令
let numberOnly = {
    bind: function(el) {
        el.handler = function() {
            el.value = el.value.replace(/[^\d.]/g, '') // 只允许“数字”和“.”字符
            el.value = el.value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
            el.value = el.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
            el.value = el.value.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
            if (el.value.indexOf('.') < 0 && el.value !== '') {
                el.value = parseFloat(el.value) + '' // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                el.value = el.value.slice(0, 6) // 没小数点，只允许6位
            }
            if (el.value.indexOf('.') > -1 && el.value !== '') {
                el.value = el.value.slice(0, 9) // 有小数点，只允许9位
            }
        }
        el.addEventListener('input', el.handler)
    },
    unbind: function(el) {
        el.removeEventListener('input', el.handler)
    }
}

let directives = {
    autoimg,
    numberOnly
}

Object.keys(directives).forEach(key => {
    useApp().directive(key, directives[key])
})
